<!-- Backdrop -->
<div 
  class="persistent-sidebar-backdrop" 
  *ngIf="visible && modal"
  [class.visible]="visible"
  (click)="onBackdropClick()">
</div>

<!-- Sidebar Panel -->
<div 
  class="persistent-sidebar-panel"
  [class.visible]="visible"
  [class.fullscreen]="fullScreen"
  [class.position-left]="position === 'left'"
  [class.position-right]="position === 'right'"
  [ngClass]="styleClass"
  [ngStyle]="getPanelStyle()">
  
  <!-- Header -->
  <div class="persistent-sidebar-header flex-column py-2" *ngIf="showCloseButton || showFullscreenButton">
    <div class="flex justify-content-end align-items-center align-self-end gap-1">
      <p-button 
        *ngIf="showFullscreenButton"
        type="button" 
        (onClick)="toggleFullscreen()" 
        icon="pi pi-window-maximize" 
        rounded="true" 
        text="true"
        styleClass="h-2rem w-2rem persistent-sidebar-header-button border-circle">
      </p-button>
      <p-button 
        *ngIf="showCloseButton"
        type="button" 
        (onClick)="close()" 
        icon="pi pi-times" 
        rounded="true" 
        text="true"
        styleClass="h-2rem w-2rem persistent-sidebar-header-button border-circle">
      </p-button>
    </div>
  </div>

  <!-- Content -->
  <div class="persistent-sidebar-content">
    <ng-content></ng-content>
  </div>
</div>

